/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_NotesInputs */

const en__field_notes = /** @type {(inputs: _Field_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {_Field_NotesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const _field_notes = /** @type {((inputs?: _Field_NotesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_NotesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_notes(inputs)
});